import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AppState } from "@redux/app-state";
import type { UserBody } from "../../../../write/domain/types/user";
import { setAccessTokenCookie, setRefreshTokenCookie } from "@utils/access-token-cookie";
import { clearImpersonationMarker } from "@shared-kernel/core/impersonation/impersonation-marker";
import { syncSession } from "../session/sync-session";

export const loginUser = createAsyncThunk<void, UserBody, { state: AppState; extra: Partial<Dependencies> }>(
  "users/loginUser",
  async (user: UserBody, { extra: { publicRepository }, dispatch }) => {
    const { accessToken, refreshToken, expiresIn, refreshTokenExpiresIn } = await publicRepository!.login(user);
    // A marker left behind by a session whose cookies expired unnoticed (tab
    // closed while impersonating) would otherwise greet this brand-new session
    // with an "impersonation expired" toast.
    clearImpersonationMarker();
    setAccessTokenCookie(accessToken, expiresIn);
    setRefreshTokenCookie(refreshToken, refreshTokenExpiresIn);
    await dispatch(syncSession());
  },
);
